import React, { useEffect } from 'react';

import { useReportingLinesStore } from '@atlassian/teams/reporting-lines';
import { useReportingLines } from '@atlassian/teams/use-reporting-lines';

import ManagersAndTeamsChart from './ReportingLines';

type ReportingLinesWithQueryProps = {
	userId: string;
	product?: string;
	/**
	 * Cloud id forwarded to `useReportingLines` for the KnowledgeDiscovery query
	 * (used when the `ptc-reporting-lines-knowledge-discovery-query` gate is
	 * enabled). Required for hosts rendered outside of `TeamsWrapper` (e.g.
	 * search); otherwise it falls back to the Teams app-config store.
	 */
	cloudId?: string;
	/**
	 * Org id forwarded to `useReportingLines` for the KnowledgeDiscovery query
	 * (used when the gate is enabled).
	 */
	orgId?: string;
};

export const ReportingLinesWithQuery = (props: ReportingLinesWithQueryProps): React.JSX.Element => {
	const { userId, cloudId, orgId } = props;

	const [{ selectedUserId }, { selectUser }] = useReportingLinesStore();
	const userToMakeRequestFor = selectedUserId ?? userId;
	const reportingLinesResponse = useReportingLines(userToMakeRequestFor, { cloudId, orgId });

	useEffect(() => {
		selectUser(userId);
	}, [userId, selectUser]);

	return <ManagersAndTeamsChart {...props} reportingLinesResponse={reportingLinesResponse} />;
};
